<template>
  <div class="mt-16">
    <v-row class="mt-1 mx-2">
      <v-col cols="12">
        <div class="mx-3 my-2">فایل ها</div>
        <v-card class="table-style">
          <div class="text-left ml-6" v-if="path !== 'public/dorak'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon large @click="getItems(path.slice(0,path.lastIndexOf('/')).trim())" class="hover-link"
                        v-bind="attrs"
                        v-on="on">mdi-arrow-left
                </v-icon>
              </template>
              <span class="tooltip-text">پوشه قبلی</span>
            </v-tooltip>
          </div>
          <v-data-table
              align="center"
              :headers="headers"
              :items="items"
              :items-per-page="20"
              disable-sort
          >
            <template v-slot:[`item.operation`]="{ item }">

              <div v-if="item.type === 'directory'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="getItems(item.path)" class="hover-link" v-bind="attrs"
                            v-on="on">mdi-arrow-left-bottom
                    </v-icon>
                  </template>
                  <span class="tooltip-text">ورود به پوشه</span>
                </v-tooltip>
              </div>
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="openItem(item.url)" class="hover-link" v-bind="attrs"
                            v-on="on">mdi-eye
                    </v-icon>
                  </template>
                  <span class="tooltip-text">مشاهده فایل</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.path`]="{ item }">
              <span v-if="item.path">
                {{ item.path }}
              </span>
              <span v-else-if="item.url">
              <v-icon color="black" @click="CopyToClipboard(item.url)" x-large>mdi-content-copy</v-icon>
              </span>
            </template>
            <template v-slot:[`item.meta.size`]="{ item }">
              <span v-if="item.meta">
                 {{ item.meta.size }}KB
              </span>
              <span v-else>
                -
              </span>
            </template>
            <template
                v-slot:[`item.type`]="{ item }">
              <div v-if="item.type">
                <div v-if="item.type === 'directory'">
                  <v-icon x-large color="black">mdi-folder</v-icon>
                </div>
                <div v-if="item.meta">
                  <div
                      v-if="item.meta.mime === 'MP4' || item.meta.mime === 'mp4' || item.meta.mime === 'AVI' || item.meta.mime === 'avi' || item.meta.mime === 'mkv' || item.meta.mime === 'MKV' || item.meta.mime === '3gp' || item.meta.mime === 'm3u8' || item.meta.mime === 'ts'">
                    <v-icon x-large color="warning">mdi-youtube</v-icon>
                  </div>
                  <div
                      v-else-if="item.meta.mime === 'MP3' || item.meta.mime === 'mp3' || item.meta.mime === 'audio' || item.meta.mime === 'AUDIO' || item.meta.mime === 'OGG' || item.meta.mime === 'ogg' || item.meta.mime === 'flac' || item.meta.mime === 'FLAC' || item.meta.mime === 'WAV' || item.meta.mime === 'wav'">
                    <v-icon x-large color="info">mdi-playlist-music-outline</v-icon>
                  </div>
                  <div
                      v-else-if="item.meta.mime === 'jpg' || item.meta.mime === 'JPG' || item.meta.mime === 'jpeg' || item.meta.mime === 'JPEG' || item.meta.mime === 'png'  || item.meta.mime === 'PNG' || item.meta.mime === 'SVG'  || item.meta.mime === 'svg' || item.meta.mime === 'gif' || item.meta.mime === 'GIF' || item.meta.mime === 'jif' || item.meta.mime === 'JIF'">
                    <v-icon x-large color="#696cff">mdi-panorama-variant-outline</v-icon>
                  </div>
                  <div
                      v-else-if="item.meta.mime === 'excel' || item.meta.mime === 'xlsx' || item.meta.mime === 'xsx' || item.meta.mime === 'csv'">
                    <v-icon x-large color="success">mdi-microsoft-excel</v-icon>
                  </div>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
export default {
  name: "FileManager",
  data() {
    return {
      headers: [
        {text: 'آیکون', value: 'type', align: 'center'},
        {text: 'نام فایل/پوشه', value: 'name', align: 'center'},
        {text: 'آدرس', value: 'path', align: 'center'},
        {text: 'نام اصلی', value: 'meta.original_name', align: 'center'},
        {text: 'نام ذخیره شده', value: 'meta.name', align: 'center'},
        {text: 'فرمت', value: 'meta.mime', align: 'center'},
        {text: 'حجم', value: 'meta.size', align: 'center'},
        {text: 'سرویس', value: 'meta.service', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center'},
      ],
      path: 'public/dorak',
      items: []
    }
  },
  mounted() {
    this.getItems(this.path)
  },

  methods: {
    CopyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.openSnackbar('لینک مورد نظر کپی شد', '#8c8eff')
    },
    getItems(path) {
      this.path = path
      window.axios.post("file-manager/direct/index", {path: path})
          .then((res) => {
            this.items = res.data.data
          })
          .catch((err) => {
            if (err.response.status === 422) {
              this.showValidationErrors(err, '#F1416C')
            } else if (err.response.status === 400) {
              this.openSnackbar(err.response.data.message, '#F1416C')
            }
          })
    },
    openItem(url) {
      window.open(url,"","width:800,height=800")
    }
  }
}
</script>

<style scoped>
.table-style {
  background: #FFFFFF;
  border: 1px solid #E9EDF4;
  border-radius: 12px;
}

td {
  color: #000000 !important;
  font-size: 20px !important;
}

.hover-link {
  color: #696cff !important;
}

.hover-link:hover {
  color: rgba(13, 132, 19, 0.67) !important;
}

.tooltip-text {
  color: white !important;
}
</style>
